import type { ComponentType } from "react";
import { CalendarWeekCard } from "./CalendarWeekCard";
import type { CalendarWidget } from "./calendarModel";
import { MeetingPickerCard } from "./MeetingPickerCard";

// One card per widget type a tool can give the chat; a new kind of card is one entry here (and its model in
// calendarModel's `widgetOf`, or a model of its own).
const WIDGETS: { [K in CalendarWidget["type"]]: ComponentType<{ widget: Extract<CalendarWidget, { type: K }> }> } = {
  meeting_picker: MeetingPickerCard,
  calendar_week: CalendarWeekCard,
};

/** The cards a reply's tools gave the chat (MHS-969), in the order the tools ran. */
export function ChatWidgets({ widgets }: Readonly<{ widgets: CalendarWidget[] }>) {
  if (widgets.length === 0) return null;
  return (
    <div className="space-y-3">
      {widgets.map((widget) => {
        const Widget = WIDGETS[widget.type] as ComponentType<{ widget: CalendarWidget }>;
        return <Widget key={widget.id} widget={widget} />;
      })}
    </div>
  );
}
